import React from 'react';
import { ModalWrapper } from 'reoverlay';

interface SettingsDialogProps {
  onClose: () => void;
  onChangeConsent: () => void;
}

export default function SettingsDialog({ onClose, onChangeConsent }: SettingsDialogProps): JSX.Element {
  return (
    <ModalWrapper 
      onClose={() => {}}   // prevent closing by clicking outside
      animation = {'fade'}
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        background: 'white',
        padding: '15px',
        borderRadius: '8px',
        boxShadow: '0 0 10px rgba(0,0,0,0.2)',
      }}
    >
      <div
          style={{
              background: 'white',
              padding: '2rem',
              borderRadius: '8px',
              maxWidth: '600px',
              margin: 'auto',
              textAlign: 'center',
          }}
      >                
          <h4>Cookie-Einstellungen</h4>
          <br></br>
          <button onClick={onChangeConsent} style={{ marginRight: '1rem', borderRadius: '8px', width: '240px', border: 0, backgroundColor: "light-gray" }}>
          Cookie-Einstellungen ändern
          </button>
          <button onClick={onClose} style={{ borderRadius: '8px', width: '240px', border: 0, backgroundColor: "light-gray" }}>
          Schließen
          </button>
      </div>
    </ModalWrapper>
  );
}
